/* Bobblery — PDP dynamic estimated delivery.
   Computes an earliest–latest window from today in BUSINESS days (skips Sat/Sun and any
   configured holiday ranges), per the selected delivery tier. Display-only: it never
   changes price and makes no hard promise. Store currency/locale: en-US. */
(function () {
  function parseHolidays(str) {
    var ranges = [];
    if (!str) return ranges;
    str.split(',').forEach(function (part) {
      var p = part.trim();
      var m = p.match(/^(\d{4}-\d{2}-\d{2})\.\.(\d{4}-\d{2}-\d{2})$/);
      if (m) {
        ranges.push([m[1], m[2]]);
      } else if (/^\d{4}-\d{2}-\d{2}$/.test(p)) {
        ranges.push([p, p]);
      }
    });
    return ranges;
  }

  function ymd(d) {
    var m = ('0' + (d.getMonth() + 1)).slice(-2);
    var day = ('0' + d.getDate()).slice(-2);
    return d.getFullYear() + '-' + m + '-' + day;
  }

  function makeIsHoliday(ranges) {
    return function (d) {
      var s = ymd(d);
      for (var i = 0; i < ranges.length; i++) {
        if (s >= ranges[i][0] && s <= ranges[i][1]) return true;
      }
      return false;
    };
  }

  // today + n business days (skips weekends + holidays). n=0 returns today.
  function addBusinessDays(start, n, isHoliday) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var added = 0;
    var guard = 0;
    while (added < n && guard < 3650) {
      guard++;
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day === 0 || day === 6) continue; // Sun / Sat
      if (isHoliday(d)) continue;
      added++;
    }
    return d;
  }

  function fmt(d) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function init(block) {
    var out = block.querySelector('.bobblery-tiers__range');
    if (!out) return;

    var buffer = parseInt(block.dataset.buffer, 10);
    if (isNaN(buffer)) buffer = 3;
    var isHoliday = makeIsHoliday(parseHolidays(block.dataset.holidays || ''));

    function update() {
      var checked = block.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      var pmin = parseInt(checked.dataset.prodMin, 10) || 0;
      var pmax = parseInt(checked.dataset.prodMax, 10) || 0;
      var ship = parseInt(checked.dataset.ship, 10) || 0;
      var today = new Date();
      var earliest = addBusinessDays(today, pmin + ship, isHoliday);
      var latest = addBusinessDays(today, pmax + ship + buffer, isHoliday);
      out.textContent = fmt(earliest) + ' – ' + fmt(latest);
    }

    block.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') update();
    });

    update();
  }

  function boot() {
    document.querySelectorAll('.bobblery-tiers').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
